module.exports = __webpack_public_path__ + "assets/img/btn-view-info-0be3652c.png";